//Popup Modal in mobile for QA_01
$('#qandaModal').on('shown.bs.modal',function(){
  if ($('.pigeonhole-iframe-modal .iframe-wrap').length == 0) {
    var $pigeonholeIframe = $('.pigeonhole-iframe .iframe-wrap').clone();
    $('.pigeonhole-iframe-modal').html($pigeonholeIframe);
  }
})